import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class accountingReport_template extends vnTemplate{

    protected validationsList: validationsList_template;
    protected accountsFilter: multipleSelector_template

    protected getTemplateHtml(): string{

        return `

           <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div>
                            <label for="idPayment" class="form-label form-label-box">Payment Date</label>
                            <select id="idPayment" data-bind="options: payments, optionsText: 'name', value: idPayment, optionsCaption: 'Select', optionsValue: 'id', valueAllowUnset: true,event: { change: onChangeFilterAction }">
                            </select>
                        </div>
                        ${this.accountsFilter.getTemplateViewModel()}
                    </div>
                    
                    <div class="w-right">
                        <button class="btn icon i-export" type="button" data-bind="visible: brandCosts().length > 0, event: { click: onClickExport }">Export</button>
                    </div>
                
                </div>
              
            </div>
            
            ` + this.validationsList.getHtmlBuild() + ` 
            
            <div class="w-double-list" data-bind="visible: brandCosts().length > 0">
            
                <div class="double-list-header">
                       <h3 class="double-list-title">Accounting Report</h3>
                </div>
                
                <div class="w-double-list-body">
                   <div class="double-list-body">
                        <div class="double-list-sub-title">
                            <strong>Grand Total CAD Costs:</strong>
                            <span data-bind="text:totalCostCAD()"></span>
                        </div>
                       
                   </div>
                   <div class="double-list-body">
                        <div class="double-list-sub-title">
                            <strong>Grand Total USD Costs:</strong>
                            <span data-bind="text: totalCostUSD()"></span>
                        </div>
                   </div>
                 </div>
                 
            </div>
            
            
           <div data-bind="foreach: brandCosts, visible: brandCosts().length > 0">
           
           <div class="w-double-list" >
                <div class="double-list-header">
                       <h3 class="double-list-title"  data-bind="text: account"></h3>
                </div>
                
                <div class="w-double-list-body">
                    <div class="double-list-body">
                       <div class="double-list-sub-title">
                            <strong>Total CAD Costs:</strong>
                            <span data-bind="text:totalCostsCAD"></span>
                       </div> 
                       <dl class="double-list">
                           <dt><span>Commission:</span></dt>
                           <dd><span data-bind="text: commissionCostCAD"></span></dd>
                           <dt><span>Performance:</span></dt>
                           <dd><span data-bind="text: performanceCostCAD"></span></dd>
                           <dt><span>Consulting Base:</span></dt>
                           <dd><span data-bind="text: consultingBaseCostCAD"></span></dd>
                           <dt><span>Bonuses:</span></dt>
                           <dd><span data-bind="text: bonusCostCAD"></span></dd>
                           <dt><span>Tips:</span></dt>
                           <dd><span data-bind="text: tipsCostCAD"></span></dd>
                           <dt><span>Hosting:</span></dt>
                           <dd><span data-bind="text: hostingCostCAD"></span></dd>
                           <dt><span>Training:</span></dt>
                           <dd><span data-bind="text: trainingCostCAD"></span></dd>
                       </dl>
                    </div>
                    <div class="double-list-body">
                       <div class="double-list-sub-title">
                            <strong>Total USD Costs:</strong>
                            <span data-bind="text:totalCostsUSD"></span>
                       </div>
                       <dl class="double-list">
                            <dt><span>Commission:</span></dt>
                           <dd><span data-bind="text: commissionCostUSD"></span></dd>
                           <dt><span>Performance:</span></dt>
                           <dd><span data-bind="text: performanceCostUSD"></span></dd>
                           <dt><span>Consulting Base:</span></dt>
                           <dd><span data-bind="text: consultingBaseCostUSD"></span></dd>
                           <dt><span>Bonuses:</span></dt>
                           <dd><span data-bind="text: bonusCostUSD"></span></dd>
                           <dt><span>Tips:</span></dt>
                           <dd><span data-bind="text: tipsCostUSD"></span></dd>
                           <dt><span>Hosting:</span></dt>
                           <dd><span data-bind="text: hostingCostUSD"></span></dd>
                           <dt><span>Training:</span></dt>
                           <dd><span data-bind="text: trainingCostUSD"></span></dd>
                       </dl>
                    </div>
                </div>
     
                </div>
             </div>
            
            `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.accountsFilter = new multipleSelector_template('accountFilter', this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{
        return "projectsTotalCost-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {
            payments: ko.observableArray([])
            ,idPayment: ko.observable('')
            ,brand: ko.observable(null)
            ,brandCosts: ko.observableArray([])
            ,totalCostCAD: ko.observable('')
            ,totalCostUSD: ko.observable('')
            ,userTaxes: ko.observableArray([])
            ,onChangeFilterAction: function (data, event) { huit_neuf_this.onChangeFilterAction(data); }
            ,onClickExport: function (data, event) { huit_neuf_this.onClickExport(data); }
        };
    }

    public onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange();
    }

    public onClickExport(data){
        this.caller.exportToCSV(data.brandCosts(),data.totalCostCAD(),data.totalCostUSD());
    }

    public setPayments(payments){
        this.getTemplateViewModel().payments(payments);
    }

    public setAccounts(accounts){
        this.getTemplateViewModel().accounts(accounts);
    }

    public setIdPayment(idPayment){
        this.getTemplateViewModel().idPayment(idPayment);
    }

    public setBrandCosts(brandCosts){
        this.getTemplateViewModel().brandCosts(brandCosts);
    }

    public setTotalCostCAD(totalCostCAD){
        this.getTemplateViewModel().totalCostCAD(totalCostCAD);
    }

    public setTotalCostUSD(totalCostUSD){
        this.getTemplateViewModel().totalCostUSD(totalCostUSD);
    }

    public setUserTaxes(userTaxes){
        this.getTemplateViewModel().userTaxes(userTaxes);
    }

    public setBrand(brand){
        this.getTemplateViewModel().brand(brand);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/accountingReport_template.ts